import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { UpdateStatusProfileService } from '../services/update-status-profile.service';
import { UpdateQassatlyInfoService } from '../services/update-qassatly-info.service';
import { UpdateProductBrowseService } from '../services/update-product-browse.service';
import { ReAssignPaymentOptionsService } from '../services/re-assign-payment-options.service';
import { UpdateCashApiStatus } from '../services/update-cash-api-status.service';
import { GetCashApi } from '../services/get-cash-api-status.service';
import { UpdateAvailableFeesService } from '../services/update-available-fees.service';
import { BusinessStatusService } from '../services/business-status.service';
import { UpdateContractStatus } from '../services/update-contract.service';
import { UpdateAdvancedSalesStatusService } from '../services/update-advances-sales-status.service';
import { GetStatusProfileService } from '../services/get-status-profile.service';
import { UpdatePendingToAvailableService } from './update-pending-to-available.service';
import { FetchRolesReportService } from '../../../roles/manage-roles/fetch-roles-report.service';
import { UpdateRoleService } from './update-role.service';
import { UpdateCreditCardLimitService } from './update-credit-card-limit.service';
import { UpdateCashWalletFeesService } from '../services/update-cash-wallet-fees.service';
import { UpdateAdvanceRepaymentFeesService } from '../services/UpdateAdvanceRepaymentFeesService';
import { FormValidatorService } from 'src/app/shared/services/form-validator.service';
import { Validators } from 'src/app/shared/validators';
import * as _ from "lodash-es";
import { UpdateAdvancedFeesService } from '../services/update-advanced-fees.service';
import { GetAssignableAdminsMangementService } from '../../../mangement/get-assignable-admins.service';
import { AssignAdminToBusinessService } from '../services/assignAdminToBusiness.service';
import { getBusinessCashbackDetailsService } from './fetch-cashback-details.service';
import { CustomValidators } from 'src/app/shared/custom-validators';
import { BaseForm } from 'src/app/shared/product/baseForm';
import { updateBusinessCashbackTiersService } from '../services/updateCashbackTiers.service';
import { FetchPaymentGroupFullDetails } from 'src/app/shared/services/fetch-payment-group-full-details.service';
import { UpdateBusinessVerificationService } from '../update-business-verifications.service';

import { UpdateBusinessInfo } from './update-business-info.service';
import { UpdateNormalFeesService } from './update-normal-fees.service';
import { UpdateUrgentFeesService } from './update-urgent-fees.service';
import { SellerActivationStatuses } from '../services/seller-activation-statuses';
@Component({
  selector: 'app-business-profile',
  templateUrl: './business-profile.component.html',
  styleUrls: ['./business-profile.component.scss']
})
export class BusinessProfileComponent extends BaseForm implements OnInit {
  @Input() data: any;
  qassatlyError: any;
  advanceSalesError: any;
  isAdmin = true;
  paymentOptions: any;
  businessName:string = '';
  withdrwaStatus: any;
  withdrawStatusOriginal: any;
  eligibleForInternational: boolean;
  eligibleForInternationalOriginal: boolean;
  pendingToAvailable !: number;
  creditCardLimitOrigin !: number;
  creditCardLimit !: number;
  pendingToAvailableOriginal !:number;
  pendingToAvailableError !: string | null;
  normalFeesOriginal!: number;
  urgentFeesOriginal!: number;
  normalFeesError!: string | null;
  urgentFeesError!: string | null;
  normalFees: number;
  urgentFees: number;
  marketingFeesOriginal: number;
  marketingFeesError!: string | null;
  marketingFees: number;
  contractStatus: any;
  contractStatusOriginal: any;
  productBrowseStatus: any;
  productBrowseStatusOriginal: any;
  cashApiStatus: any;
  cashApiStatusOriginal: any;
  marchantPercentage: any;
  cashWalletPercentageOriginal: number;
  cashWalletPercentage: number;
  advanceRepaymentPercentageOriginal: number;
  advanceRepaymentPercentage: number;
  advancedPercentageOriginal: number;
  advancedPercentage: number;
  merchantPercentageOriginal: any;
  businessId: any;
  qassatlyStatus: any;
  qassatlyLimit: any;
  qassatlyOriginalLimit: any;
  qassatlyMonthlyLimit: any;
  qassatlyOriginalMonthlyLimit: any;
  advanceSalesStatus: any;
  advanceSalesStatusOriginal: any;
  cashBackForm: FormGroup;
  @Input() tierObject: any;
  cashBackStatus: any;
  cashBackError: any;
  qassatlyOriginalStatus: any;
  availableFeesError: any;
  availableFeesStatus: any;
  availableFeesPercentage: any;
  availableFeesPercentageOriginal:number;
  merchantID: any;
  advanceSalesLimit: any;
  paymentForm!: FormGroup;
  paymentGroupOptions: paymentGroup[] = [];
  paymentGroupOptionsOriginal: paymentGroup[] = [];
  paymentGroupError: boolean = false;
  paymentOptionsError: any;
  businessStatus: string = "";
  businessOriginalStatus: any;
  rolesData: any;
  sellerId: any;
  adminOrSellerRoleId!: string;
  availableFeesStatusOriginal: boolean;
  previousSellerPaymentOptions: boolean[] = [];
  recursion: boolean = false;
  paymentOptionsForm: FormGroup;
  paymentOptionsFeesOriginal: {[key: number]: number} = {};
  paymentOptionsUpdated:boolean;
  admins: IAdmin[];
  contractStatusList: ContractStatus[];
  oldAssignedAdminId = 0;
  newAssignedAdminId = 0;
  businessVerifications: BusinessVerifications;
  boPhone : string;
  boPhoneOriginal:string;
  boPhoneError:any;
  boEmail: string;
  boEmailOriginal:string;
  boEmailError : any ;
  activationStatuses: any[];
  tierController = {
    "Amount":
    {
      'fieldName': 'Amount',
      'fieldNameAr': 'القيمة',
      'fieldType': 'Amount',
      'isStaticUI': true,
      defaultValue: '0',
      validators: [
        {
          validatorFn: Validators.required,
          message: `${this.validationMsg.required}`,
          messageAr: `${this.validationMsgAr.required}`
        },
        {
          validatorFn: Validators.min(1),
          message: `${this.validationMsg.min}1`,
          messageAr: `${this.validationMsgAr.min}1`
        },
        {
          validatorFn: CustomValidators.customPattern(/^[0-9]*$/),
          message: `${this.validationMsg.requiredNumber}`,
          messageAr: `${this.validationMsgAr.requiredNumber}`
        },
      ]
    },
    "Rate":
    {
      'fieldName': 'Rate',
      'fieldNameAr': 'النسبة المئوية',
      'fieldType': 'Rate',
      'isStaticUI':true,
      defaultValue: '0',
      validators: [
        {
          validatorFn: Validators.required,
          message: `${this.validationMsg.required}`,
          messageAr: `${this.validationMsgAr.required}`
        },
        {
          validatorFn: CustomValidators.customPattern(/^[0]\.[0-9]+$/),
          message: `${this.validationMsg.requiredFloat}`,
          messageAr: `${this.validationMsgAr.requiredFloat}`
        },
      ]
    },
  };

  controllers: any = {
    "Cashback Tiers":
    {
      'fieldName': 'Cashback Tiers',
      'fieldNameAr': 'عناصر العائد',
      'fieldType': 'Cashback Tiers',
      'isStaticUI': true,
      defaultValue: '',
      validators: []
    },
  }

  constructor(
    private getStatusProfileService: GetStatusProfileService,
    private activatedRoute: ActivatedRoute,
    private updateStatusProfileService: UpdateStatusProfileService,
    private updateQassatlyInfoService: UpdateQassatlyInfoService,
    private updateProductBrowseService: UpdateProductBrowseService,
    private updateContractStatus: UpdateContractStatus,
    private setCashApiStatus: UpdateCashApiStatus,
    private advancedSalesStatusService: UpdateAdvancedSalesStatusService,
    private getCashApi: GetCashApi,
    private cdr: ChangeDetectorRef,
    private fb: FormBuilder,
    private reAssignPaymentOptions: ReAssignPaymentOptionsService,
    private fetchPaymentGroupsDetails: FetchPaymentGroupFullDetails,
    private updateAvailableFeesService: UpdateAvailableFeesService,
    private updatePendingToAvailableService : UpdatePendingToAvailableService,
    private businessStatusService: BusinessStatusService,
    public fetchRoles: FetchRolesReportService,
    private updateRoleService: UpdateRoleService,
    private updateCCLimit: UpdateCreditCardLimitService,
    private updateCashWalletFees: UpdateCashWalletFeesService,
    private formService: FormValidatorService,
    private updateAdvanceRepaymentFeesService : UpdateAdvanceRepaymentFeesService,
    private updateAdvancedFeesService : UpdateAdvancedFeesService,
    private getAssignableAdminsService: GetAssignableAdminsMangementService,
    private assignAdminToBusiness: AssignAdminToBusinessService,
    private getBusinessCashbackDetails: getBusinessCashbackDetailsService,
    private updateBusinessCashbackTiers: updateBusinessCashbackTiersService,
    private updateBusinessVerificationService: UpdateBusinessVerificationService,
    private updateBusinessInfoService : UpdateBusinessInfo,
    private updateNormalFeesService: UpdateNormalFeesService,
    private updateUrgentFeesService: UpdateUrgentFeesService,
    private sellerActivationStatuses: SellerActivationStatuses,
  ) {
    super();
    this.businessVerifications = {email: false, phone: false , facebook : false};
    this.contractStatusList = [
      ContractStatus.confirmed,
      ContractStatus.empty,
      ContractStatus.shipped,
      ContractStatus.signed,
      ContractStatus.submitted,
    ];
    console.log("contractStatusList ", this.contractStatusList);
  }

  async ngOnInit() {
    this.activatedRoute.params.subscribe(async params => {
      const sellerStatusResp = await this.sellerActivationStatuses.make();
      this.activationStatuses = Object.entries(sellerStatusResp).map((val) => ({
        key: val[0],
        value: val[1],
      }));

      this.businessVerifications.email = this.data.Verification.mail_verified ?? false;
      this.businessVerifications.phone = this.data.Verification.phone_verified ?? false;
      this.businessVerifications.id = this.data.Verification.id;
      this.businessVerifications.facebook = this.data.Verification.facebook_verified ?? false;

      this.businessId = params["id"];
      this.getStatusProfileService.setParams({ id: params["id"] });
      const response:statusProfile = await this.getStatusProfileService.make();
      this.businessName = response.bushiness.name
      this.oldAssignedAdminId = response.bushiness.adminId;
      this.creditCardLimit = this.creditCardLimitOrigin =
        +response.bushiness.creditCardLimit;
      this.cashWalletPercentage = this.cashWalletPercentageOriginal =
        +response.bushiness.cashWalletFees;
      this.advanceRepaymentPercentage = this.advanceRepaymentPercentageOriginal =
        +response.bushiness.AdvanceRepaymentFees;
      this.advancedPercentage = this.advancedPercentageOriginal =
        +response.bushiness.AdvancedFees;
      this.withdrawStatusOriginal = this.withdrwaStatus = !!response.res[0].can_withdraw;
      if (response.res[0].eligibleForInternational === null) {
        this.eligibleForInternationalOriginal = this.eligibleForInternational =  true;
      } else {
        this.eligibleForInternationalOriginal = this.eligibleForInternational = !!response.res[0].eligibleForInternational;
      }
      this.marketingFees = this.marketingFeesOriginal = +response.res[0].marketingFees;
      this.adminOrSellerRoleId = response.res[0].RoleId;
      this.contractStatusOriginal = response.bushiness.contractStatus;
      this.sellerId = response.res[0].sellerId;
      this.advanceSalesLimit = response.bushiness.advancedSalesLimit
      if (response.bushiness.advancedSalesLimit == null) {
        this.advanceSalesStatusOriginal = this.advanceSalesStatus = false
      } else {
        this.advanceSalesStatusOriginal = this.advanceSalesStatus = true

      }
      this.productBrowseStatusOriginal = this.productBrowseStatus = response.res[0].productBrowseFlag > 0;
      this.merchantPercentageOriginal = this.marchantPercentage = response.res[0].fees;
      const qassatlyId = response.res[0].qassatlyId;
      this.qassatlyOriginalStatus = this.qassatlyStatus = !!qassatlyId;
      if (!this.qassatlyOriginalStatus) {
        //default value if no qassatly status returned from the database
        this.qassatlyOriginalLimit = this.qassatlyLimit = "800";
        this.qassatlyOriginalMonthlyLimit = this.qassatlyMonthlyLimit = "5000"
      } else {
        this.qassatlyOriginalLimit = this.qassatlyLimit =
          response.res[0].qassatlyLimit;
        this.qassatlyOriginalMonthlyLimit = this.qassatlyMonthlyLimit =
          response.res[0].qassatlyMonthlyLimit;
      }

      this.availableFeesStatus = this.availableFeesStatusOriginal =
        !!response.bushiness.availableFeesPercentage;
      this.availableFeesPercentage = this.availableFeesPercentageOriginal=response.bushiness.availableFeesPercentage;
      this.pendingToAvailable = this.pendingToAvailableOriginal = response.bushiness.pendingToAvailable;
      this.businessOriginalStatus = this.businessStatus = response.bushiness.activeStatus;
      this.normalFees = this.normalFeesOriginal = response.bushiness.normalFees;
      this.urgentFees = this.urgentFeesOriginal = response.bushiness.urgentFees;
      this.merchantID = qassatlyId;

      this.fetchPaymentGroupsDetails.setParams({businessId:this.businessId})
      this.paymentGroupOptionsOriginal = this.paymentGroupOptions = await this.fetchPaymentGroupsDetails.make();

      this.getCashApi.setParams({ businessId: this.businessId });
      const cashApiKey = await this.getCashApi.make();
      this.cashApiStatusOriginal = this.cashApiStatus = cashApiKey.enabled;
      this.cdr.detectChanges()
    this.fetchRoles.setParams({});
    const report = await this.fetchRoles.make();
    this.rolesData = report.result.filter((role: { type: string; })=>{
      return role.type != 'Admin'
    })|| [];
    await this.getAdmins();

    this.cashBackForm = this.fb.group({
      Cashback_Details: this.fb.array([])
    });
    this.addCashbackTiers();


    this.getBusinessCashbackDetails.setParams({ businessId: this.businessId })
    const res = await this.getBusinessCashbackDetails.make();
    this.cashBackStatus = res.cashbackFlag
    if (res.businessTiers.length > 0) {
      for(let i=0; i<res.businessTiers.length; i++) {
        this.addCashbackTiers();
        this.CashbackTiers.controls[i].setValue({
            "Amount": +res.businessTiers[i].amount,
            "Rate": +res.businessTiers[i].rate,
        })
      }
    }
    this.boPhone = this.boPhoneOriginal = this.data.phone ;
    this.boEmail =this.boEmailOriginal = this.data.email ;
  });
  }

  ngAfterViewInit() {
    if (this.tierObject) {
      const Cashback_Details = this.tierObject.Cashback_Details || [];
      for (const tier of Cashback_Details) {
        this.addTier(tier);
      }
    }
  }

  get CashbackTiers() {
    return this.cashBackForm.get('Cashback_Details') as FormArray;
  }

  get verificationStatus(){
    return VerificationStatus;
  }

  async addTier(object?: any) {
    if (object) {
      this.addCashbackTiers();
      this.CashbackTiers.controls[this.CashbackTiers.controls.length - 1].setValue({
        "Amount": +object.amount,
        "Rate": +object.rate,
      })
    }
    else {
      this.formService.forceShowErrors();
    }
  }

  addCashbackTiers() {
    if (this.CashbackTiers.valid) {
      this.CashbackTiers.push(this.formService.createForm(Object.values(this.tierController)));
    }
  }

  removeTiers(i: number) {
    if (this.CashbackTiers.controls.length !== 1){
    this.CashbackTiers.removeAt(i);
    }
  }

  async updateBusinessTiers() {
    try {
    let cashbackTiers:{amount:number,rate:number}[] = [];
    for (let tier of this.CashbackTiers.controls) {
      if (tier.valid) {
        cashbackTiers.push(tier.value)
      }
    }
    this.updateBusinessCashbackTiers.setParams({
      businessId: this.businessId,
      cashbackTiers,
      cashbackFlag: this.cashBackStatus
    })
    this.updateBusinessCashbackTiers.make()
    } catch (error) {
      this.cashBackError = error.faultyRequest.error.message;
    }
  }

  async getAdmins() {
    this.admins = await this.getAssignableAdminsService.make()
  }

  async updatePaymentOptions() {
    let check = false;
    for(let group of this.paymentGroupOptions){
      if(group.enable) check = true;
    }
    if(!check)return;
    this.reAssignPaymentOptions.setParams({groups : this.paymentGroupOptions, businessId: this.businessId});
    this.reAssignPaymentOptions.make();
  }

  async updateWithdraw() {
    if (this.withdrawStatusOriginal === this.withdrwaStatus) {
      return;
    }
    this.updateStatusProfileService.setParams({
      id: this.businessId,
      withDrawFlag: this.withdrwaStatus
    });
    await this.updateStatusProfileService.make();
    this.withdrawStatusOriginal = this.withdrwaStatus;
  }

  async updateEligibleForInternational() {
    if (this.eligibleForInternationalOriginal === this.eligibleForInternational) {
      return;
    }
    this.updateStatusProfileService.setParams({
      id: this.businessId,
      eligibleForInternational: this.eligibleForInternational
    });
    await this.updateStatusProfileService.make();
    this.eligibleForInternationalOriginal = this.eligibleForInternational;
  }

  async updateMarketingFees() {
    console.log({marketingFeesError: this.marketingFeesError, marketingFees: this.marketingFees, marketingFeesOriginal: this.marketingFeesOriginal})
    this.marketingFeesError = null;
    if (this.marketingFees === this.marketingFeesOriginal) return;
    if (this.marketingFees === null) {
      this.marketingFeesError = 'required field';
      return;
    }
    if (this.marketingFees < 0) {
      this.marketingFeesError = 'it should be positive';
      return;
    }
    if (this.marketingFees > 99.99) {
      this.marketingFeesError = 'enter a number lower than 100';
      return;
    }
    try {
      this.updateStatusProfileService.setParams({
        id: this.businessId,
        marketingFees: this.marketingFees
      });
      await this.updateStatusProfileService.make();
      this.marketingFeesOriginal = this.marketingFees;
      console.log({msg: "after res", marketingFeesError: this.marketingFeesError, marketingFees: this.marketingFees, marketingFeesOriginal: this.marketingFeesOriginal})
    } catch (error) {
      this.marketingFeesError = error.faultyRequest.error.message;
    }
  }
  async updateCashApiStatus() {
    if (this.cashApiStatusOriginal === this.cashApiStatus) {
      return;
    }
    this.setCashApiStatus.setParams({
      businessId: this.businessId,
      status: this.cashApiStatus
    });
    await this.setCashApiStatus.make();
    this.cashApiStatusOriginal = this.cashApiStatus;
    this.cdr.detectChanges()
  }

  async updateProductBrowse() {
    if (this.productBrowseStatusOriginal === this.productBrowseStatus) {
      return;
    }
    this.updateProductBrowseService.setParams({
      id: this.businessId,
      productBrowseFlag: this.productBrowseStatus
    });
    await this.updateProductBrowseService.make();
    this.productBrowseStatusOriginal = this.productBrowseStatus;
    this.cdr.detectChanges()
  }

  async updateBusinessVerifications(){
    if(!this.businessVerifications.id) return;
    this.updateBusinessVerificationService.setParams({
      verificationId: this.businessVerifications.id,
      email: this.businessVerifications.email,
      phone: this.businessVerifications.phone,
      facebook : this.businessVerifications.facebook
    });
    await this.updateBusinessVerificationService.make();
  }

  async submitActionInfo() {
    await this.updatePaymentOptions()
    await this.updateWithdrawalStatus();
    await this.updateEligibleForInternational();
    await this.assignQasstlyMerchants();
    await this.updateAvailableFeesPercentage();
    await this.updatePendingToAvailable();
    await this.updateWithdraw();
    await this.updateProductBrowse();
    await this.updateCashApiStatus();
    await this.updateBusinessStatus();
    await this.updateContract()
    await this.updateAdvancesSalesStatus()
    await this.updateAdminOrSellerRole();
    await this.updateCreditCardLimit();
    await this.updateBusinessCashWalletFees();
    await this.updateAdvanceRepaymentFees();
    await this.updateAdvancedFees();
    await this.updateAssignedAdmin()
    await this.updateBusinessTiers();
    await this.updateBusinessVerifications();
    await this.updateBusinessInfo();
    await this.updateNormalFees();
    await this.updateUrgentFees();
    await this.updateMarketingFees();
  }

  async updateContract() {
    if(!this.contractStatus) return;
    if (this.contractStatus == this.contractStatusOriginal) return;

    this.contractStatusOriginal = this.contractStatus
    this.updateContractStatus.setParams({
      businessId: this.businessId,
      status: this.contractStatus
    })
    await this.updateContractStatus.make();
  }
  async updateAdvancesSalesStatus() {

    this.advanceSalesError = null;
    try {
      this.advancedSalesStatusService.setParams({
        businessId: this.businessId,
        status: this.advanceSalesStatus,
        advanceSalesLimit: this.advanceSalesLimit,
      });
      let res = await this.advancedSalesStatusService.make();
      this.advanceSalesStatusOriginal = this.advanceSalesStatus;
      if (res.status == "wrong") {
        this.advanceSalesError = res.message
      } else {
        this.advanceSalesError = null;
      }
    } catch (error) {
      this.advanceSalesError = error.faultyRequest.error.message;
    }

  }
  async updateBusinessStatus() {
    if (this.businessOriginalStatus === this.businessStatus) {
      return;
    }
    this.businessStatusService.setParams({
      businessId: this.businessId,
      activeStatus: this.businessStatus
    });
    await this.businessStatusService.make();
    this.businessOriginalStatus = this.businessStatus;
  }
  async updateBusinessInfo (){
    if (this.boEmail === this.boEmailOriginal && this.boPhone === this.boPhoneOriginal){
      return
    }
    if (!this.validateBOEmail()||!this.validateBOPhone)return
    this.updateBusinessInfoService.setParams({
      businessId : this.businessId ,
      phone : this.boPhone ,
      email : this.boEmail
    })
    try {
      await this.updateBusinessInfoService.make();
    }catch(err){
      if(err.faultyRequest.error.message.includes('Email')){
        this.boEmailError = err.faultyRequest.error.message
      }else{
        this.boPhoneError = err.faultyRequest.error.message
      }
    }

  }
  validateBOPhone (){
    const regex = new RegExp(/^(\+201|01|00201)[0-2,5]{1}[0-9]{8}/,'g')
    const phone = this.boPhone
    if (phone == null || phone === ""){
      this.boPhoneError = "Business Owner phone should not be empty";
      return false;
    }
    let ismatch = phone.match(regex)

    if (ismatch[0]===phone){
      this.boPhoneError = null
      return true;
    }else {
      this.boPhoneError = "Business owner phone should be in valid format";
      return false;
    }
  }
  validateBOEmail(){
    const regex = new RegExp(/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/)
    const email = this.boEmail;
    if (email == null || email === "" ){
      this.boEmailError = "Business Owner email should not be empty";
      return false;
    }
    let isEmail = regex.test(email);
    if (isEmail){
      this.boEmailError = null
      return true;
    }else{
      this.boEmailError = "Business owner email should be in valid format";
      return false;
    }

  }
  convertCashBackFormControls(index: number, name: string) {
    return this.CashbackTiers.controls[index].get(name) as FormControl;
  }

  async changeQassatly(qassatlyFlag: any) {
    this.qassatlyStatus = qassatlyFlag;
    this.qassatlyError = null;
  }
  async changeAdvanceSalesStatus(advanceSalesFlag: any) {
    this.advanceSalesStatus = advanceSalesFlag;
    this.advanceSalesError = null;
  }
  async changeCashbackStatus(cashBackFlag: any) {
    this.cashBackStatus = cashBackFlag;
    this.cashBackError = null;
  }

  async changeAvailableFees(availableFeesFlag: any) {
    this.availableFeesStatus = availableFeesFlag;
    this.availableFeesError = null;
  }

  async updateWithdrawalStatus() {
    if (this.merchantPercentageOriginal === this.marchantPercentage) {
      return;
    }
    if (this.marchantPercentage < 0 || this.marchantPercentage > 100) {
      return;
    }
    this.updateStatusProfileService.setParams({
      id: this.businessId,
      fees: this.marchantPercentage
    });
    const result = await this.updateStatusProfileService.make();
    this.merchantPercentageOriginal = this.marchantPercentage = result.res;
  }

  async assignQasstlyMerchants() {
    this.qassatlyError = null;
    if (this.qassatlyOriginalStatus === this.qassatlyStatus
      && this.qassatlyOriginalLimit === this.qassatlyLimit
      && this.qassatlyOriginalMonthlyLimit === this.qassatlyMonthlyLimit) {
      return;
    }
    if (this.qassatlyStatus === false) {
      this.updateQassatlyInfoService.setParams({ isEnabled: this.qassatlyStatus, businessId: this.businessId })
      await this.updateQassatlyInfoService.make();
      this.qassatlyOriginalStatus = this.qassatlyStatus
      this.merchantID = null
    }

    try {
      this.updateQassatlyInfoService.setParams({
        businessId: this.businessId,
        isEnabled: this.qassatlyStatus,
        fees: this.marchantPercentage,
        businessName: this.businessName,
        QassatlyLimit: this.qassatlyLimit,
        qassatlyMonthlyLimit: this.qassatlyMonthlyLimit
      });
      let res = await this.updateQassatlyInfoService.make();
      this.merchantID = res.merchantId
      this.qassatlyOriginalStatus = this.qassatlyStatus;
    } catch (error) {
      this.qassatlyError = error.faultyRequest.error.message;
    }
  }

  async updateAvailableFeesPercentage() {
    this.availableFeesError = null;
    if (this.availableFeesStatus === this.availableFeesStatusOriginal) {
      if (!this.availableFeesStatus) return;
      if (
        this.availableFeesStatus &&
        this.availableFeesPercentage == this.availableFeesPercentageOriginal
      )
        return;
    }
    if (this.availableFeesStatus) {
      if (!this.availableFeesPercentage) {
        this.availableFeesError = 'required field';
        return;
      }
      if (this.availableFeesPercentage <= 0) {
        this.availableFeesError = 'it should be positive';
        return;
      }
      if (this.availableFeesPercentage > 100) {
        this.availableFeesError = 'percentage should be less than 100';
        return;
      }
    }
    try {
      this.updateAvailableFeesService.setParams({
        businessId: this.businessId,
        percentage: this.availableFeesPercentage,
        isEnabled: this.availableFeesStatus
      });
      await this.updateAvailableFeesService.make();
      this.availableFeesPercentageOriginal=this.availableFeesPercentage;
    } catch (error) {
      this.availableFeesError = error.faultyRequest.error.message;
    }
  }

  async updateAssignedAdmin() {
    if(this.oldAssignedAdminId == this.newAssignedAdminId){
      return
    }
    this.assignAdminToBusiness.setParams({
      businessId: this.businessId,
      adminId: this.newAssignedAdminId
    })
    await this.assignAdminToBusiness.make()
  }

  async updatePendingToAvailable(){
    this.pendingToAvailableError = null;
    if (this.pendingToAvailable === this.pendingToAvailableOriginal)return;
    if (this.pendingToAvailable < 0){
      this.pendingToAvailableError = 'it should be positive';
      return;
    }
    try {
      this.updatePendingToAvailableService.setParams({
        businessId: this.businessId,
        days: this.pendingToAvailable,
        isEnabled: true
      });
      await this.updatePendingToAvailableService.make();
    } catch (error) {
      this.availableFeesError = error.faultyRequest.error.message;
    }
  }

  async updateNormalFees() {
    this.normalFeesError = null;
    if (this.normalFees === this.normalFeesOriginal) return;
    if (this.normalFees === null) this.normalFeesError = 'required field';
    if (this.normalFees < 0) {
      this.normalFeesError = 'it should be positive';
      return;
    }
    try {
      this.updateNormalFeesService.setParams({
        businessId: this.businessId,
        normalFees: this.normalFees,
      });
      await this.updateNormalFeesService.make();
    } catch (error) {
      this.normalFeesError = error.faultyRequest.error.message;
    }
  }

  async updateUrgentFees() {
    this.urgentFeesError = null;
    if (this.urgentFees === this.urgentFeesOriginal) return;
    if (this.urgentFees === null) this.urgentFeesError = 'required field';
    if (this.urgentFees < 0) {
      this.urgentFeesError = 'it should be positive';
      return;
    }
    try {
      this.updateUrgentFeesService.setParams({
        businessId: this.businessId,
        urgentFees: this.urgentFees,
      });
      await this.updateUrgentFeesService.make();
    } catch (error) {
      this.urgentFeesError = error.faultyRequest.error.message;
    }
  }

  onRoleSelectedChange(value:string){
    this.adminOrSellerRoleId= value;
  }

  onAdminSelectedChange(value: number){
    this.newAssignedAdminId = value;
  }

  onContractSignChange(value: string){
    this.contractStatus = value;
  }

  async updateAdminOrSellerRole(){
    this.updateRoleService.setParams({
      id: this.businessId,
      RoleId: this.adminOrSellerRoleId,
    });
    await this.updateRoleService.make();
    this.cdr.detectChanges();
  }

  async updateCreditCardLimit() {
    if(this.creditCardLimit == this.creditCardLimitOrigin) return
    this.updateCCLimit.setParams({
      businessId: this.businessId,
      creditCardLimit: this.creditCardLimit,
    });
    await this.updateCCLimit.make()
    // this.cdr.detectChanges();
  }

  async updateBusinessCashWalletFees(){
    if(this.cashWalletPercentage == this.cashWalletPercentageOriginal) return
    this.updateCashWalletFees.setParams({
      businessId: this.businessId,
      cashWalletFees: this.cashWalletPercentage
    })
    await this.updateCashWalletFees.make()

  }
  async updateAdvanceRepaymentFees(){
    if(this.advanceRepaymentPercentage == this.advanceRepaymentPercentageOriginal) return
    this.updateAdvanceRepaymentFeesService.setParams({
      businessId: this.businessId,
      percentage: this.advanceRepaymentPercentage
    })
    await this.updateAdvanceRepaymentFeesService.make()
  }

  async updateAdvancedFees(){
    if(this.advancedPercentage == this.advancedPercentageOriginal) return
    this.updateAdvancedFeesService.setParams({
      businessId: this.businessId,
      percentage: this.advancedPercentage
    })
    await this.updateAdvancedFeesService.make()
  }
  disablePaymentGroup(groupIndex:number){
    for(let index = 0; index < this.paymentGroupOptions[groupIndex].paymentOptions.length; index++){
      this.paymentGroupOptions[groupIndex].paymentOptions[index].enabled = false;
    }
    this.paymentGroupOptions[groupIndex].enable = false;
    let check = false;
    for(let group of this.paymentGroupOptions){
      if(group.enable) check = true;
    }
    if(!check) this.paymentGroupError =true;
  }
  handlePaymentOptionClick(groupIndex:number,optionIndex:number){
    this.paymentGroupError = false;
    for(let index = 0; index < this.paymentGroupOptions[groupIndex].paymentOptions.length; index++){
      this.paymentGroupOptions[groupIndex].paymentOptions[index].enabled = false;
    }
    if (this.paymentGroupOptions[groupIndex].enable) {
      this.paymentGroupOptions[groupIndex].paymentOptions[optionIndex].enabled =
        true;
    } else {
      this.paymentGroupOptions[groupIndex].enable = true;
      this.paymentGroupOptions[groupIndex].fees =
        this.paymentGroupOptionsOriginal[groupIndex].fees >= 0
          ? this.paymentGroupOptionsOriginal[groupIndex].fees
          : 3.5; //defaultValue
      this.paymentGroupOptions[groupIndex].paymentOptions[optionIndex].enabled =
        true;
    }
  }

}

interface statusProfile{
  res:sellerOptions[],
  bushiness:businessOption
}
interface paymentGroup{
        name: string;
        fees: number
        enable : boolean;
        paymentOptions: Array<{id:number; name: string; enabled:boolean }>;
}
interface businessOption{
    id: number,
    name: string,
    description:string| null,
    code: string,
    logo: string,
    fees: 3.50,
    fees_type: string,
    can_withdraw: boolean,
    productBrowseFlag: boolean,
    cs_email: string,
    cs_phone: string,
    link_fb: null | string,
    link_tw: null | string,
    link_li: null | string,
    activationSteps: null | string,
    availableFeesPercentage: null | number,
    contractSubmittedAt: null | string,
    advancedSalesLimit: null | string,
    enabel_advancedSales: boolean,
    activeStatus: string ,
    facebook_likes: any,
    contractStatus: string,
    pendingToAvailable: 7,
    last_signin:Date,
    creditCardLimit: string,
    customPaymentFeesOnBuyer: boolean,
    businessType: null,
    cashWalletFees: number,
    AdvanceRepaymentFees: number,
    RecurringWithdrawal: string,
    AdvancedFees: number,
    createdAt: Date,
    updatedAt: Date,
    CategoryId: null,
    adminId: number,
    normalFees:number,
    urgentFees:number
}
interface sellerOptions{

      sellerId: string,
      Bstatus: string,
      RoleId: string,
      qassatlyId: number,
      qassatlyLimit: number,
      qassatlyMonthlyLimit: number,
      can_withdraw: 0 | 1,
      productBrowseFlag: 0 | 1,
      fees: number,
      marketingFees: number,
      advancedSalesLimit: number,
      eligibleForInternational: 0 | 1 | null,
}

interface IAdmin {
  id: number;
  first_name: string;
  last_name: string;
  email: string;
  password: string;
  force_logout: number;
  createdAt: string;
  updatedAt: string;
  deletedAt?: any;
  RoleId: number;
  ref: string;
  phone?: any;
  status?: any;
  isOwner: number;
  SellerId?: any;
  BusinessId?: any;
  name: string;
}

enum VerificationStatus {
  verified = 'Verified',
  unVerified = 'Unverified'
}

type BusinessVerifications = {
  id?: number,
  email: boolean,
  phone: boolean,
  facebook : boolean
}


enum ContractStatus {
  confirmed = 'confirmed',
  empty = 'empty',
  shipped = 'shipped',
  signed = 'signed',
  submitted = 'submitted'
}
